// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', features?: { __typename: 'Features', id: string, marketingEnabled?: boolean, marketingEnabledSMS?: boolean, marketingEnabledCall?: boolean, marketingEnabledDirectMail?: boolean, videoNotificationsDisabled?: boolean, uBTC?: boolean, mBTC?: boolean, VIP?: boolean, Insider?: boolean, isAmsUser?: boolean } };

export type TagsFragment = { __typename: 'Features', id: string, marketingEnabled?: boolean, marketingEnabledSMS?: boolean, marketingEnabledCall?: boolean, marketingEnabledDirectMail?: boolean, videoNotificationsDisabled?: boolean, uBTC?: boolean, mBTC?: boolean, VIP?: boolean, Insider?: boolean, isAmsUser?: boolean };

export const TagsFragmentDoc = /*#__PURE__*/ gql`
    fragment TagsFragment on Features {
  __typename
  id
  marketingEnabled: hasTag(name: "marketingEnabled")
  marketingEnabledSMS: hasTag(name: "marketingEnabledSMS")
  marketingEnabledCall: hasTag(name: "marketingEnabledCall")
  marketingEnabledDirectMail: hasTag(name: "marketingEnabledDirectMail")
  videoNotificationsDisabled: hasTag(name: "videoNotificationsDisabled")
  uBTC: hasTag(name: "uBTC")
  mBTC: hasTag(name: "mBTC")
  VIP: hasTag(name: "VIP")
  Insider: hasTag(name: "Insider")
  isAmsUser: hasTag(name: "Agent System User")
}
    `;
export const TagsQueryDocument = /*#__PURE__*/ gql`
    query TagsQuery {
  features {
    ...TagsFragment
  }
}
    ${TagsFragmentDoc}`;
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsQueryDocument, options);
      }
export function useTagsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsQueryDocument, options);
        }
export function useTagsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsQueryDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsQueryLazyQueryHookResult = ReturnType<typeof useTagsQueryLazyQuery>;
export type TagsQuerySuspenseQueryHookResult = ReturnType<typeof useTagsQuerySuspenseQuery>;
export type TagsQueryQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;